// extracted by mini-css-extract-plugin
export default {"title":"ContentTitle_title__ODkIc","divider":"ContentTitle_divider__-LQWh"};